// // // // // import React, { useState, useEffect } from 'react';
// // // // // import { useSelector } from 'react-redux';
// // // // // import { useNavigate } from 'react-router-dom';
// // // // // import axios from 'axios';
// // // // // import './StudentView1.css';

// // // // // const backendURL = process.env.REACT_APP_backend_url;

// // // // // const StudentView = () => {
// // // // //   const [projects, setProjects] = useState([]);
// // // // //   const [loading, setLoading] = useState(true);
// // // // //   const [error, setError] = useState(null);
// // // // //   const [showCongrats, setShowCongrats] = useState(false);
// // // // //   const [selectedProject, setSelectedProject] = useState(null);

// // // // //   const studentId = useSelector((state) => state.User.currentUser.rollId);
// // // // //   const department = useSelector((state) => state.User.currentUser.department);
// // // // //   const navigate = useNavigate();

// // // // //   useEffect(() => {
// // // // //     const fetchProjects = async () => {
// // // // //       try {
// // // // //         const token = sessionStorage.getItem('Token');
// // // // //         setLoading(true);
// // // // //         setError(null);

// // // // //         const response = await axios.post(
// // // // //           `${backendURL}/projects_published`,
// // // // //           [department, studentId],
// // // // //           {
// // // // //             headers: {
// // // // //               'Content-Type': 'application/json',
// // // // //               Authorization: `Bearer ${token}`,
// // // // //             },
// // // // //             withCredentials: true,
// // // // //           }
// // // // //         );

// // // // //         setProjects(response.data.published_projects || []);
// // // // //         if (response.data.student_project) {
// // // // //           setSelectedProject(response.data.student_project);
// // // // //         }

// // // // //         setLoading(false);
// // // // //       } catch (err) {
// // // // //         console.error('Error fetching projects:', err);
// // // // //         setError('Failed to load projects. Please try again later.');
// // // // //         setLoading(false);
// // // // //       }
// // // // //     };

// // // // //     fetchProjects();
// // // // //   }, [department]);

// // // // //   const handleInterestedClick = async (project) => {
// // // // //     const data = {
// // // // //       facultyId: project.roll_id,
// // // // //       studentId: studentId,
// // // // //       projectId: project.project_id,
// // // // //     };

// // // // //     try {
// // // // //       const token = sessionStorage.getItem('Token');

// // // // //       const res = await axios.post(
// // // // //         `${backendURL}/add_student_to_project`,
// // // // //         data,
// // // // //         {
// // // // //           headers: {
// // // // //             'Content-Type': 'application/json',
// // // // //             Authorization: `Bearer ${token}`,
// // // // //           },
// // // // //           withCredentials: true,
// // // // //         }
// // // // //       );

// // // // //       if (res.data.error) {
// // // // //         alert(res.data.error);
// // // // //         return;
// // // // //       }

// // // // //       if (res.data.already_assigned) {
// // // // //         alert('You have already selected a project!');
// // // // //       } else {
// // // // //         setShowCongrats(true);
// // // // //         setSelectedProject(res.data.selected_project);
// // // // //         setTimeout(() => setShowCongrats(false), 5000);
// // // // //       }
// // // // //     } catch (error) {
// // // // //       console.error('Error adding student to project:', error);
// // // // //       alert('Something went wrong. Please try again.');
// // // // //     }
// // // // //   };

// // // // //   const filteredProjects = selectedProject
// // // // //     ? projects.filter((p) => p.project_id !== selectedProject.project_id)
// // // // //     : projects;

// // // // //   return (
// // // // //     <div className="student-view-container">
// // // // //       <h1 className="text-center p-2 m-1 text-3xl font-bold relative border-4 border-purple-500 rounded-lg shadow-md before:absolute before:inset-0 before:rounded-lg before:border-4 before:border-cyan-400 before:blur-md before:opacity-50 animate-pulse">
// // // // //         Available Projects
// // // // //       </h1>

// // // // //       {selectedProject && (
// // // // //         <div className="selected-project-horizontal">
// // // // //           <div className="selected-project-info">
// // // // //             <h2>🎯 You have joined this project</h2>
// // // // //             <p><strong>Title:</strong> {selectedProject.title}</p>
// // // // //             <p><strong>Abstract:</strong> {selectedProject.abstract}</p>
// // // // //             <p><strong>Requirements:</strong> {selectedProject.requirements}</p>
// // // // //           </div>
// // // // //         </div>
// // // // //       )}

// // // // //       {loading && (
// // // // //         <div className="student-view-loader">
// // // // //           <div className="student-view-spinner"></div>
// // // // //           <p>Loading projects...</p>
// // // // //         </div>
// // // // //       )}

// // // // //       {error && (
// // // // //         <div className="student-view-error">
// // // // //           <p>{error}</p>
// // // // //         </div>
// // // // //       )}

// // // // //       {!loading && !error && (
// // // // //         <div className="student-view-grid">
// // // // //           {filteredProjects.length > 0 ? (
// // // // //             filteredProjects.map((project) => (
// // // // //               <div key={project.project_id} className="student-view-card">
// // // // //                 <div className="student-view-card-header">
// // // // //                   <h2>{project.title}</h2>
// // // // //                   <span className={`student-view-status ${project.publish}`}>
// // // // //                     PUBLISHED
// // // // //                   </span>
// // // // //                 </div>
// // // // //                 <div className="student-view-card-body">
// // // // //                   <p><strong>Abstract:</strong> {project.abstract}</p>
// // // // //                   <p><strong>Requirements:</strong> {project.requirements}</p>
// // // // //                 </div>
// // // // //                 <div className="student-view-card-footer">
// // // // //                   {!selectedProject && (
// // // // //                     project.student_count >= 5 ? (
// // // // //                       <span className="student-view-full-badge">
// // // // //                         ✅ Requirement Fulfilled
// // // // //                       </span>
// // // // //                     ) : (
// // // // //                       <button
// // // // //                         className="student-view-interested-btn"
// // // // //                         onClick={() => handleInterestedClick(project)}
// // // // //                       >
// // // // //                         I am Interested
// // // // //                       </button>
// // // // //                     )
// // // // //                   )}
// // // // //                 </div>
// // // // //               </div>
// // // // //             ))
// // // // //           ) : (
// // // // //             <p className="student-view-no-projects">
// // // // //               No projects available at the moment.
// // // // //             </p>
// // // // //           )}
// // // // //         </div>
// // // // //       )}

// // // // //       {showCongrats && (
// // // // //         <div className="congrats-overlay">
// // // // //           <div className="congrats-message">
// // // // //             <h2>Congratulations!</h2>
// // // // //             <p>You have successfully joined the project!</p>
// // // // //           </div>
// // // // //           <div className="petal-animation">
// // // // //             {[...Array(50)].map((_, index) => (
// // // // //               <div
// // // // //                 key={index}
// // // // //                 className="petal"
// // // // //                 style={{
// // // // //                   left: `${Math.random() * 100}%`,
// // // // //                   animationDuration: `${Math.random() * 5 + 8}s`,
// // // // //                 }}
// // // // //               ></div>
// // // // //             ))}
// // // // //           </div>
// // // // //         </div>
// // // // //       )}
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default StudentView;
// // // // import React, { useState, useEffect } from 'react';
// // // // import { useSelector } from 'react-redux';
// // // // import { useNavigate } from 'react-router-dom';
// // // // import axios from 'axios';
// // // // import './StudentView1.css';

// // // // const backendURL = process.env.REACT_APP_backend_url;

// // // // const StudentView = () => {
// // // //   const [projects, setProjects] = useState([]);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [error, setError] = useState(null);
// // // //   const [showCongrats, setShowCongrats] = useState(false);
// // // //   const [selectedProject, setSelectedProject] = useState(null);

// // // //   const studentId = useSelector((state) => state.User.currentUser.rollId);
// // // //   const department = useSelector((state) => state.User.currentUser.department);
// // // //   const navigate = useNavigate();

// // // //   useEffect(() => {
// // // //     const fetchProjects = async () => {
// // // //       try {
// // // //         const token = sessionStorage.getItem('Token');
// // // //         setLoading(true);
// // // //         setError(null);

// // // //         const response = await axios.get(
// // // //           `${backendURL}/published_projects/${department}`,
// // // //           {
// // // //             headers: {
// // // //               'Content-Type': 'application/json',
// // // //               Authorization: `Bearer ${token}`,
// // // //             },
// // // //             withCredentials: true,
// // // //           }
// // // //         );

// // // //         setProjects(response.data || []);

// // // //         // Fetch selected project if already assigned
// // // //         const assignedResponse = await axios.post(
// // // //           `${backendURL}/projects_published`,
// // // //           [department, studentId],
// // // //           {
// // // //             headers: {
// // // //               'Content-Type': 'application/json',
// // // //               Authorization: `Bearer ${token}`,
// // // //             },
// // // //             withCredentials: true,
// // // //           }
// // // //         );

// // // //         if (assignedResponse.data.student_project) {
// // // //           setSelectedProject(assignedResponse.data.student_project);
// // // //         }

// // // //         setLoading(false);
// // // //       } catch (err) {
// // // //         console.error('Error fetching projects:', err);
// // // //         setError('Failed to load projects. Please try again later.');
// // // //         setLoading(false);
// // // //       }
// // // //     };

// // // //     fetchProjects();
// // // //   }, [department, studentId]);

// // // //   const handleInterestedClick = async (project) => {
// // // //     const data = {
// // // //       facultyId: project.faculty_id,
// // // //       studentId: studentId,
// // // //       projectId: project.project_id,
// // // //     };

// // // //     try {
// // // //       const token = sessionStorage.getItem('Token');

// // // //       const res = await axios.post(
// // // //         `${backendURL}/add_student_to_project`,
// // // //         data,
// // // //         {
// // // //           headers: {
// // // //             'Content-Type': 'application/json',
// // // //             Authorization: `Bearer ${token}`,
// // // //           },
// // // //           withCredentials: true,
// // // //         }
// // // //       );

// // // //       if (res.data.error) {
// // // //         alert(res.data.error);
// // // //         return;
// // // //       }

// // // //       if (res.data.already_assigned) {
// // // //         alert('You have already selected a project!');
// // // //       } else {
// // // //         setShowCongrats(true);
// // // //         setSelectedProject(res.data.selected_project);
// // // //         setTimeout(() => setShowCongrats(false), 5000);
// // // //       }
// // // //     } catch (error) {
// // // //       console.error('Error adding student to project:', error);
// // // //       alert('Something went wrong. Please try again.');
// // // //     }
// // // //   };

// // // //   const filteredProjects = selectedProject
// // // //     ? projects.filter((p) => p.project_id !== selectedProject.project_id)
// // // //     : projects;

// // // //   return (
// // // //     <div className="student-view-container">
// // // //       <h1 className="text-center p-2 m-1 text-3xl font-bold relative border-4 border-purple-500 rounded-lg shadow-md before:absolute before:inset-0 before:rounded-lg before:border-4 before:border-cyan-400 before:blur-md before:opacity-50 animate-pulse">
// // // //         Available Projects
// // // //       </h1>

// // // //       {/* Selected Project */}
// // // //       {selectedProject && (
// // // //         <div className="selected-project-horizontal">
// // // //           <div className="selected-project-info">
// // // //             <h2>🎯 You have joined this project</h2>
// // // //             <p><strong>Title:</strong> {selectedProject.title}</p>
// // // //             <p><strong>Abstract:</strong> {selectedProject.abstract}</p>
// // // //             <p><strong>Requirements:</strong> {selectedProject.requirements}</p>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {/* Loader */}
// // // //       {loading && (
// // // //         <div className="student-view-loader">
// // // //           <div className="student-view-spinner"></div>
// // // //           <p>Loading projects...</p>
// // // //         </div>
// // // //       )}

// // // //       {/* Error */}
// // // //       {error && (
// // // //         <div className="student-view-error">
// // // //           <p>{error}</p>
// // // //         </div>
// // // //       )}

// // // //       {/* Projects */}
// // // //       {!loading && !error && (
// // // //         <div className="student-view-grid">
// // // //           {filteredProjects.length > 0 ? (
// // // //             filteredProjects.map((project) => (
// // // //               <div key={project.project_id} className="student-view-card">
// // // //                 <div className="student-view-card-header">
// // // //                   <h2>{project.title}</h2>
// // // //                   <span className="student-view-status">PUBLISHED</span>
// // // //                 </div>
// // // //                 <div className="student-view-card-body">
// // // //                   <p><strong>Abstract:</strong> {project.abstract}</p>
// // // //                   <p><strong>Requirements:</strong> {project.requirements}</p>
// // // //                   <p><strong>Domain:</strong> {project.domain}</p>
// // // //                   <p><strong>Assigned Students:</strong> {project.student_count || 0} / 5</p>
// // // //                 </div>
// // // //                 <div className="student-view-card-footer">
// // // //                   {!selectedProject && (
// // // //                     project.student_count >= 5 ? (
// // // //                       <span className="student-view-full-badge">
// // // //                         ✅ Requirement Fulfilled
// // // //                       </span>
// // // //                     ) : (
// // // //                       <button
// // // //                         className="student-view-interested-btn"
// // // //                         onClick={() => handleInterestedClick(project)}
// // // //                       >
// // // //                         I am Interested
// // // //                       </button>
// // // //                     )
// // // //                   )}
// // // //                 </div>
// // // //               </div>
// // // //             ))
// // // //           ) : (
// // // //             <p className="student-view-no-projects">
// // // //               No projects available at the moment.
// // // //             </p>
// // // //           )}
// // // //         </div>
// // // //       )}

// // // //       {/* Congrats Overlay */}
// // // //       {showCongrats && (
// // // //         <div className="congrats-overlay">
// // // //           <div className="congrats-message">
// // // //             <h2>Congratulations!</h2>
// // // //             <p>You have successfully joined the project!</p>
// // // //           </div>
// // // //           <div className="petal-animation">
// // // //             {[...Array(50)].map((_, index) => (
// // // //               <div
// // // //                 key={index}
// // // //                 className="petal"
// // // //                 style={{
// // // //                   left: `${Math.random() * 100}%`,
// // // //                   animationDuration: `${Math.random() * 5 + 8}s`,
// // // //                 }}
// // // //               ></div>
// // // //             ))}
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default StudentView;
// // // // import React, { useState, useEffect } from 'react';
// // // // import { useSelector } from 'react-redux';
// // // // import { useNavigate } from 'react-router-dom';
// // // // import axios from 'axios';
// // // // import './StudentView1.css';

// // // // const backendURL = process.env.REACT_APP_backend_url;

// // // // const StudentView = () => {
// // // //   const [projects, setProjects] = useState([]);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [error, setError] = useState(null);
// // // //   const [showCongrats, setShowCongrats] = useState(false);
// // // //   const [selectedProject, setSelectedProject] = useState(null);

// // // //   const studentId = useSelector((state) => state.User.currentUser.rollId);
// // // //   const department = useSelector((state) => state.User.currentUser.department);
// // // //   const navigate = useNavigate();

// // // //   // Fetch all published projects and selected project if any
// // // //   useEffect(() => {
// // // //     const fetchProjects = async () => {
// // // //       try {
// // // //         const token = sessionStorage.getItem('Token');
// // // //         setLoading(true);
// // // //         setError(null);

// // // //         // Fetch all published projects for the department
// // // //         const response = await axios.get(
// // // //           `${backendURL}/published_projects/${department}`,
// // // //           {
// // // //             headers: {
// // // //               'Content-Type': 'application/json',
// // // //               Authorization: `Bearer ${token}`,
// // // //             },
// // // //             withCredentials: true,
// // // //           }
// // // //         );
// // // //         // console.log(response.data,"this is for department")

// // // //         setProjects(response.data || []);

// // // //         // Fetch already assigned project for this student
// // // //         const assignedResponse = await axios.post(
// // // //           `${backendURL}/projects_published`,
// // // //           [department, studentId],
// // // //           {
// // // //             headers: {
// // // //               'Content-Type': 'application/json',
// // // //               Authorization: `Bearer ${token}`,
// // // //             },
// // // //             withCredentials: true,
// // // //           }
// // // //         );

// // // //         if (assignedResponse.data.student_project) {
// // // //           console.log(assignedResponse.data.student_project)
// // // //           setSelectedProject(assignedResponse.data.student_project);
// // // //         }

// // // //         setLoading(false);
// // // //       } catch (err) {
// // // //         console.error('Error fetching projects:', err);
// // // //         setError('Failed to load projects. Please try again later.');
// // // //         setLoading(false);
// // // //       }
// // // //     };

// // // //     fetchProjects();
// // // //   }, [department, studentId]);

// // // //   // Handle "I am Interested" button click
// // // //   const handleInterestedClick = async (project) => {
// // // //     const data = {
// // // //       facultyId: project.faculty_id,
// // // //       studentId: studentId,
// // // //       projectId: project.project_id,
// // // //     };

// // // //     try {
// // // //       const token = sessionStorage.getItem('Token');
// // // //       const res = await axios.post(
// // // //         `${backendURL}/add_student_to_project`,
// // // //         data,
// // // //         {
// // // //           headers: {
// // // //             'Content-Type': 'application/json',
// // // //             Authorization: `Bearer ${token}`,
// // // //           },
// // // //           withCredentials: true,
// // // //         }
// // // //       );

// // // //       if (res.data.error) {
// // // //         alert(res.data.error);
// // // //         return;
// // // //       }

// // // //       if (res.data.already_assigned) {
// // // //         alert('You have already selected a project!');
// // // //       } else {
// // // //         setShowCongrats(true);
// // // //         setSelectedProject(res.data.selected_project);
// // // //         setTimeout(() => setShowCongrats(false), 5000);
// // // //       }
// // // //     } catch (error) {
// // // //       console.error('Error adding student to project:', error);
// // // //       alert('Something went wrong. Please try again.');
// // // //     }
// // // //   };

// // // //   // Filter out the selected project from the list
// // // //   const filteredProjects = selectedProject
// // // //     ? projects.filter((p) => p.project_id !== selectedProject.project_id)
// // // //     : projects;

// // // //   return (
// // // //     <div className="student-view-container">
// // // //       <h1 className="text-center p-2 m-1 text-3xl font-bold relative border-4 border-purple-500 rounded-lg shadow-md before:absolute before:inset-0 before:rounded-lg before:border-4 before:border-cyan-400 before:blur-md before:opacity-50 animate-pulse">
// // // //         Available Projects
// // // //       </h1>

// // // //       {/* Show Selected Project */}
// // // //       {selectedProject && (
// // // //         <div className="selected-project-horizontal">
// // // //           <div className="selected-project-info">
// // // //             <h2>🎯 You have joined this project</h2>
// // // //             <p><strong>Title:</strong> {selectedProject.title}</p>
// // // //             <p><strong>Abstract:</strong> {selectedProject.abstract}</p>
// // // //             <p><strong>Requirements:</strong> {selectedProject.requirements}</p>
// // // //             <p><strong>Faculty:</strong> {selectedProject.staff_name}</p>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {/* Loader */}
// // // //       {loading && (
// // // //         <div className="student-view-loader">
// // // //           <div className="student-view-spinner"></div>
// // // //           <p>Loading projects...</p>
// // // //         </div>
// // // //       )}

// // // //       {/* Error Message */}
// // // //       {error && (
// // // //         <div className="student-view-error">
// // // //           <p>{error}</p>
// // // //         </div>
// // // //       )}

// // // //       {/* Project Cards */}
// // // //       {!loading && !error && (
// // // //         <div className="student-view-grid">
// // // //           {filteredProjects.length > 0 ? (
// // // //             filteredProjects.map((project) => (
// // // //               <div key={project.project_id} className="student-view-card">
// // // //                 <div className="student-view-card-header">
// // // //                   <h2>{project.title}</h2>
// // // //                   <span className="student-view-status">PUBLISHED</span>
// // // //                 </div>
// // // //                 <div className="student-view-card-body">
// // // //                 <p><strong>Faculty:</strong> {project.staff_name}</p>
// // // //                   <p><strong>Abstract:</strong> {project.abstract}</p>
// // // //                   <p><strong>Requirements:</strong> {project.requirements}</p>
// // // //                   <p><strong>Domain:</strong> {project.domain}</p>
// // // //                   <p><strong>Assigned Students:</strong> {project.student_count || 0} / 5</p>

// // // //                   {/* List of students who have joined the project */}
// // // //                   {project.student_names && project.student_roll_ids && (
// // // //                   <div className="mt-2">
// // // //                     <p><strong>Students Joined:</strong></p>
// // // //                     <ul className="list-disc ml-5">
// // // //                       {project.student_names.split(',').map((name, idx) => {
// // // //                         const rollIds = project.student_roll_ids.split(',');
// // // //                         return (
// // // //                           <li key={idx}>
// // // //                             {name.trim()} ({rollIds[idx]?.trim()})
// // // //                           </li>
// // // //                         );
// // // //                       })}
// // // //                     </ul>
// // // //                   </div>
// // // //                   )}

// // // //                 </div>
// // // //                 <div className="student-view-card-footer">
// // // //                   {!selectedProject && (
// // // //                     project.student_count >= 5 ? (
// // // //                       <span className="student-view-full-badge">
// // // //                         ✅ Requirement Fulfilled
// // // //                       </span>
// // // //                     ) : (
// // // //                       <button
// // // //                         className="student-view-interested-btn"
// // // //                         onClick={() => handleInterestedClick(project)}
// // // //                       >
// // // //                         I am Interested
// // // //                       </button>
// // // //                     )
// // // //                   )}
// // // //                 </div>
// // // //               </div>
// // // //             ))
// // // //           ) : (
// // // //             <p className="student-view-no-projects">
// // // //               No projects available at the moment.
// // // //             </p>
// // // //           )}
// // // //         </div>
// // // //       )}

// // // //       {/* Congratulations Overlay */}
// // // //       {showCongrats && (
// // // //         <div className="congrats-overlay">
// // // //           <div className="congrats-message">
// // // //             <h2>Congratulations!</h2>
// // // //             <p>You have successfully joined the project!</p>
// // // //           </div>
// // // //           <div className="petal-animation">
// // // //             {[...Array(50)].map((_, index) => (
// // // //               <div
// // // //                 key={index}
// // // //                 className="petal"
// // // //                 style={{
// // // //                   left: `${Math.random() * 100}%`,
// // // //                   animationDuration: `${Math.random() * 5 + 8}s`,
// // // //                 }}
// // // //               ></div>
// // // //             ))}
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default StudentView;

// // // import { useState, useEffect } from 'react';
// // // import { useSelector } from 'react-redux';
// // // import { useNavigate } from 'react-router-dom';
// // // import axios from 'axios';

// // // export default function StudentView() {
// // //   const [projects, setProjects] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);
// // //   const [showCongrats, setShowCongrats] = useState(false);
// // //   const [selectedProject, setSelectedProject] = useState(null);

// // //   // Get data from Redux store
// // //   const studentId = useSelector((state) => state.User.currentUser.rollId);
// // //   const department = useSelector((state) => state.User.currentUser.department);
// // //   const navigate = useNavigate();
  
// // //   // Get backend URL from environment variables
// // //   const backendURL = process.env.REACT_APP_backend_url;

// // //   // Fetch all published projects and selected project if any
// // //   useEffect(() => {
// // //     const fetchProjects = async () => {
// // //       try {
// // //         const token = sessionStorage.getItem('Token');
// // //         setLoading(true);
// // //         setError(null);

// // //         // Fetch all published projects for the department
// // //         const response = await axios.get(
// // //           `${backendURL}/published_projects/${department}`,
// // //           {
// // //             headers: {
// // //               'Content-Type': 'application/json',
// // //               Authorization: `Bearer ${token}`,
// // //             },
// // //             withCredentials: true,
// // //           }
// // //         );

// // //         setProjects(response.data || []);

// // //         // Fetch already assigned project for this student
// // //         const assignedResponse = await axios.post(
// // //           `${backendURL}/projects_published`,
// // //           [department, studentId],
// // //           {
// // //             headers: {
// // //               'Content-Type': 'application/json',
// // //               Authorization: `Bearer ${token}`,
// // //             },
// // //             withCredentials: true,
// // //           }
// // //         );

// // //         if (assignedResponse.data.student_project) {
// // //           setSelectedProject(assignedResponse.data.student_project);
// // //         }

// // //         setLoading(false);
// // //       } catch (err) {
// // //         console.error('Error fetching projects:', err);
// // //         setError('Failed to load projects. Please try again later.');
// // //         setLoading(false);
// // //       }
// // //     };

// // //     fetchProjects();
// // //   }, [department, studentId, backendURL]);

// // //   // Handle "I am Interested" button click
// // //   const handleInterestedClick = async (project) => {
// // //     const data = {
// // //       facultyId: project.faculty_id,
// // //       studentId: studentId,
// // //       projectId: project.project_id,
// // //     };

// // //     try {
// // //       const token = sessionStorage.getItem('Token');
// // //       const res = await axios.post(
// // //         `${backendURL}/add_student_to_project`,
// // //         data,
// // //         {
// // //           headers: {
// // //             'Content-Type': 'application/json',
// // //             Authorization: `Bearer ${token}`,
// // //           },
// // //           withCredentials: true,
// // //         }
// // //       );

// // //       if (res.data.error) {
// // //         alert(res.data.error);
// // //         return;
// // //       }

// // //       if (res.data.already_assigned) {
// // //         alert('You have already selected a project!');
// // //       } else {
// // //         setShowCongrats(true);
// // //         setSelectedProject(res.data.selected_project);
// // //         setTimeout(() => setShowCongrats(false), 5000);
// // //       }
// // //     } catch (error) {
// // //       console.error('Error adding student to project:', error);
// // //       alert('Something went wrong. Please try again.');
// // //     }
// // //   };

// // //   // Filter out the selected project from the list
// // //   const filteredProjects = selectedProject
// // //     ? projects.filter((p) => p.project_id !== selectedProject.project_id)
// // //     : projects;

// // //   return (
// // //     <div className="max-w-7xl mx-auto px-4 py-8 bg-gray-50 min-h-screen">
// // //       {/* Page Header */}
// // //       <h1 className="text-center py-4 mb-6 text-3xl font-bold text-indigo-800 relative">
// // //         <span className="relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600">
// // //           Available Projects
// // //         </span>
// // //         <div className="absolute inset-0 bg-indigo-100 rounded-lg transform -skew-y-1 shadow-md"></div>
// // //       </h1>

// // //       {/* Selected Project */}
// // //       {selectedProject && (
// // //         <div className="mb-8 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border-l-4 border-emerald-500 p-6 shadow-md">
// // //           <div className="flex items-center mb-3">
// // //             <div className="bg-emerald-500 text-white p-2 rounded-full mr-3">
// // //               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// // //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
// // //               </svg>
// // //             </div>
// // //             <h2 className="text-xl font-bold text-emerald-800">You have joined this project</h2>
// // //           </div>
          
// // //           <div className="pl-11">
// // //             <h3 className="text-lg font-semibold text-emerald-700 mb-2">{selectedProject.title}</h3>
// // //             <p className="mb-2"><span className="font-medium">Faculty:</span> {selectedProject.staff_name}</p>
// // //             <p className="mb-2"><span className="font-medium">Abstract:</span> {selectedProject.abstract}</p>
// // //             <p className="mb-2"><span className="font-medium">Requirements:</span> {selectedProject.requirements}</p>
// // //             <p className="mb-2"><span className="font-medium">Domain:</span> {selectedProject.domain}</p>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* Loading State */}
// // //       {loading && (
// // //         <div className="flex flex-col items-center justify-center py-12">
// // //           <div className="w-16 h-16 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin"></div>
// // //           <p className="mt-4 text-indigo-600 font-medium">Loading projects...</p>
// // //         </div>
// // //       )}

// // //       {/* Error State */}
// // //       {error && (
// // //         <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded shadow-md">
// // //           <div className="flex">
// // //             <div className="flex-shrink-0">
// // //               <svg className="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
// // //                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
// // //               </svg>
// // //             </div>
// // //             <div className="ml-3">
// // //               <p className="text-sm text-red-700">{error}</p>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* Project Grid */}
// // //       {!loading && !error && (
// // //         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
// // //           {filteredProjects.length > 0 ? (
// // //             filteredProjects.map((project) => (
// // //               <div 
// // //                 key={project.project_id} 
// // //                 className="bg-white rounded-lg overflow-hidden shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
// // //               >
// // //                 <div className="p-6">
// // //                   <div className="flex justify-between items-start mb-4">
// // //                     <h2 className="text-xl font-bold text-gray-800 leading-tight">{project.title}</h2>
// // //                     <span className="bg-indigo-100 text-indigo-800 text-xs font-semibold px-2.5 py-1 rounded">PUBLISHED</span>
// // //                   </div>
                  
// // //                   <div className="space-y-2 mb-4">
// // //                     <p className="flex items-center text-gray-700">
// // //                       <span className="font-medium mr-1">Faculty:</span> 
// // //                       <span>{project.staff_name}</span>
// // //                     </p>
// // //                     <p className="text-gray-700">
// // //                       <span className="font-medium">Abstract:</span> 
// // //                       <span className="block mt-1 text-sm">{project.abstract}</span>
// // //                     </p>
// // //                     <p className="text-gray-700">
// // //                       <span className="font-medium">Requirements:</span> 
// // //                       <span className="block mt-1 text-sm">{project.requirements}</span>
// // //                     </p>
// // //                     <p className="text-gray-700">
// // //                       <span className="font-medium">Domain:</span> 
// // //                       <span className="text-sm ml-1">{project.domain}</span>
// // //                     </p>
// // //                     <div className="flex items-center">
// // //                       <span className="font-medium text-gray-700">Students:</span>
// // //                       <div className="ml-2 flex items-center">
// // //                         <div className="flex -space-x-2">
// // //                           {Array.from({ length: Math.min(project.student_count, 3) }).map((_, idx) => (
// // //                             <div key={idx} className="w-6 h-6 rounded-full bg-indigo-500 text-white flex items-center justify-center text-xs border-2 border-white">
// // //                               {(project.student_names?.split(',')[idx] || '?').charAt(0)}
// // //                             </div>
// // //                           ))}
// // //                         </div>
// // //                         <span className="ml-2 text-sm text-gray-600">{project.student_count || 0} / 5</span>
// // //                       </div>
// // //                     </div>
// // //                   </div>

// // //                   {/* Students who joined */}
// // //                   {project.student_names && project.student_roll_ids && project.student_count > 0 && (
// // //                     <div className="mt-4 bg-gray-50 p-3 rounded-md">
// // //                       <p className="font-medium text-sm text-gray-700 mb-1">Students Joined:</p>
// // //                       <ul className="space-y-1">
// // //                         {project.student_names.split(',').map((name, idx) => {
// // //                           const rollIds = project.student_roll_ids.split(',');
// // //                           return (
// // //                             <li key={idx} className="text-sm text-gray-600 flex items-center">
// // //                               <svg className="h-3 w-3 text-indigo-500 mr-1" fill="currentColor" viewBox="0 0 20 20">
// // //                                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
// // //                               </svg>
// // //                               {name.trim()} ({rollIds[idx]?.trim()})
// // //                             </li>
// // //                           );
// // //                         })}
// // //                       </ul>
// // //                     </div>
// // //                   )}
// // //                 </div>

// // //                 <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
// // //                   {!selectedProject && (
// // //                     project.student_count >= 5 ? (
// // //                       <div className="bg-green-100 text-green-800 text-sm font-medium py-2 px-3 rounded-md flex items-center justify-center">
// // //                         <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
// // //                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
// // //                         </svg>
// // //               import { useState, useEffect } from 'react';
// // import { useSelector } from 'react-redux';
// // import { useNavigate } from 'react-router-dom';
// // import axios from 'axios';

// // export default function StudentView() {
// //   const [projects, setProjects] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [showCongrats, setShowCongrats] = useState(false);
// //   const [selectedProject, setSelectedProject] = useState(null);

// //   // Get data from Redux store
// //   const studentId = useSelector((state) => state.User.currentUser.rollId);
// //   const department = useSelector((state) => state.User.currentUser.department);
// //   const navigate = useNavigate();
  
// //   // Get backend URL from environment variables
// //   const backendURL = process.env.REACT_APP_backend_url;

// //   // Fetch all published projects and selected project if any
// //   useEffect(() => {
// //     const fetchProjects = async () => {
// //       try {
// //         const token = sessionStorage.getItem('Token');
// //         setLoading(true);
// //         setError(null);

// //         // Fetch all published projects for the department
// //         const response = await axios.get(
// //           `${backendURL}/published_projects/${department}`,
// //           {
// //             headers: {
// //               'Content-Type': 'application/json',
// //               Authorization: `Bearer ${token}`,
// //             },
// //             withCredentials: true,
// //           }
// //         );

// //         setProjects(response.data || []);

// //         // Fetch already assigned project for this student
// //         const assignedResponse = await axios.post(
// //           `${backendURL}/projects_published`,
// //           [department, studentId],
// //           {
// //             headers: {
// //               'Content-Type': 'application/json',
// //               Authorization: `Bearer ${token}`,
// //             },
// //             withCredentials: true,
// //           }
// //         );

// //         if (assignedResponse.data.student_project) {
// //           setSelectedProject(assignedResponse.data.student_project);
// //         }

// //         setLoading(false);
// //       } catch (err) {
// //         console.error('Error fetching projects:', err);
// //         setError('Failed to load projects. Please try again later.');
// //         setLoading(false);
// //       }
// //     };

// //     fetchProjects();
// //   }, [department, studentId, backendURL]);

// //   // Handle "I am Interested" button click
// //   const handleInterestedClick = async (project) => {
// //     const data = {
// //       facultyId: project.faculty_id,
// //       studentId: studentId,
// //       projectId: project.project_id,
// //     };

// //     try {
// //       const token = sessionStorage.getItem('Token');
// //       const res = await axios.post(
// //         `${backendURL}/add_student_to_project`,
// //         data,
// //         {
// //           headers: {
// //             'Content-Type': 'application/json',
// //             Authorization: `Bearer ${token}`,
// //           },
// //           withCredentials: true,
// //         }
// //       );

// //       if (res.data.error) {
// //         alert(res.data.error);
// //         return;
// //       }

// //       if (res.data.already_assigned) {
// //         alert('You have already selected a project!');
// //       } else {
// //         setShowCongrats(true);
// //         setSelectedProject(res.data.selected_project);
// //         setTimeout(() => setShowCongrats(false), 5000);
// //       }
// //     } catch (error) {
// //       console.error('Error adding student to project:', error);
// //       alert('Something went wrong. Please try again.');
// //     }
// //   };

// //   // Filter out the selected project from the list
// //   const filteredProjects = selectedProject
// //     ? projects.filter((p) => p.project_id !== selectedProject.project_id)
// //     : projects;

// //   return (
// //     <div className="max-w-7xl mx-auto px-4 py-8 bg-gray-50 min-h-screen">
// //       {/* Page Header */}
// //       <h1 className="text-center py-4 mb-6 text-3xl font-bold text-indigo-800 relative">
// //         <span className="relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600">
// //           Available Projects
// //         </span>
// //         <div className="absolute inset-0 bg-indigo-100 rounded-lg shadow-md"></div>
// //       </h1>

// //       {/* Selected Project */}
// //       {selectedProject && (
// //         <div className="mb-8 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border-l-4 border-emerald-500 p-6 shadow-md">
// //           <div className="flex items-center mb-3">
// //             <div className="bg-emerald-500 text-white p-2 rounded-full mr-3">
// //               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
// //               </svg>
// //             </div>
// //             <h2 className="text-xl font-bold text-emerald-800">You have joined this project</h2>
// //           </div>
          
// //           <div className="pl-11">
// //             <h3 className="text-lg font-semibold text-emerald-700 mb-2 truncate">{selectedProject.title}</h3>
// //             <p className="mb-2"><span className="font-medium">Faculty:</span> {selectedProject.staff_name}</p>
// //             <p className="mb-2"><span className="font-medium">Abstract:</span> <span className="line-clamp-3">{selectedProject.abstract}</span></p>
// //             <p className="mb-2"><span className="font-medium">Requirements:</span> <span className="line-clamp-2">{selectedProject.requirements}</span></p>
// //             <p className="mb-2"><span className="font-medium">Domain:</span> {selectedProject.domain}</p>
// //           </div>
// //         </div>
// //       )}

// //       {/* Loading State */}
// //       {loading && (
// //         <div className="flex flex-col items-center justify-center py-12">
// //           <div className="w-16 h-16 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin"></div>
// //           <p className="mt-4 text-indigo-600 font-medium">Loading projects...</p>
// //         </div>
// //       )}

// //       {/* Error State */}
// //       {error && (
// //         <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded shadow-md">
// //           <div className="flex">
// //             <div className="flex-shrink-0">
// //               <svg className="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
// //                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
// //               </svg>
// //             </div>
// //             <div className="ml-3">
// //               <p className="text-sm text-red-700">{error}</p>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* Project Grid */}
// //       {!loading && !error && (
// //         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-8">
// //           {filteredProjects.length > 0 ? (
// //             filteredProjects.map((project) => (
// //               <div 
// //                 key={project.project_id} 
// //                 className="bg-white rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300 flex flex-col min-h-[400px] max-h-[500px]"
// //               >
// //                 <div className="p-5 flex-1 overflow-hidden">
// //                   <div className="flex justify-between items-start mb-3">
// //                     <h2 className="text-lg font-bold text-gray-800 leading-tight truncate">{project.title}</h2>
// //                     <span className="bg-indigo-100 text-indigo-800 text-xs font-semibold px-2 py-0.5 rounded uppercase">Published</span>
// //                   </div>
                  
// //                   <div className="space-y-2 mb-4 text-sm">
// //                     <p className="text-gray-700">
// //                       <span className="font-medium">Faculty:</span> 
// //                       <span className="truncate">{project.staff_name}</span>
// //                     </p>
// //                     <p className="text-gray-700">
// //                       <span className="font-medium">Abstract:</span> 
// //                       <span className="block mt-1 line-clamp-4">{project.abstract}</span>
// //                     </p>
// //                     <p className="text-gray-700">
// //                       <span className="font-medium">Requirements:</span> 
// //                       <span className="block mt-1 line-clamp-2">{project.requirements}</span>
// //                     </p>
// //                     <p className="text-gray-700">
// //                       <span className="font-medium">Domain:</span> 
// //                       <span className="ml-1">{project.domain}</span>
// //                     </p>
// //                     <div className="flex items-center">
// //                       <span className="font-medium text-gray-700">Students:</span>
// //                       <div className="ml-2 flex items-center">
// //                         <div className="flex -space-x-2">
// //                           {Array.from({ length: Math.min(project.student_count, 3) }).map((_, idx) => (
// //                             <div key={idx} className="w-6 h-6 rounded-full bg-indigo-500 text-white flex items-center justify-center text-xs border-2 border-white">
// //                               {(project.student_names?.split(',')[idx] || '?').charAt(0)}
// //                             </div>
// //                           ))}
// //                         </div>
// //                         <span className="ml-2 text-gray-600">{project.student_count || 0} / 5</span>
// //                       </div>
// //                     </div>
// //                   </div>

// //                   {/* Students who joined */}
// //                   {project.student_names && project.student_roll_ids && project.student_count > 0 && (
// //                     <div className="mt-3 bg-gray-50 p-2 rounded-md">
// //                       <p className="font-medium text-xs text-gray-700 mb-1">Students Joined:</p>
// //                       <ul className="space-y-1">
// //                         {project.student_names.split(',').map((name, idx) => {
// //                           const rollIds = project.student_roll_ids.split(',');
// //                           return (
// //                             <li key={idx} className="text-xs text-gray-600 flex items-center">
// //                               <svg className="h-3 w-3 text-indigo-500 mr-1" fill="currentColor" viewBox="0 0 20 20">
// //                                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
// //                               </svg>
// //                               {name.trim()} ({rollIds[idx]?.trim()})
// //                             </li>
// //                           );
// //                         })}
// //                       </ul>
// //                     </div>
// //                   )}
// //                 </div>

// //                 <div className="px-5 py-3 bg-gray-50 border-t border-gray-100">
// //                   {!selectedProject && (
// //                     project.student_count >= 5 ? (
// //                       <div className="bg-green-100 text-green-800 text-xs font-medium py-2 px-3 rounded-md flex items-center justify-center">
// //                         <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
// //                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
// //                         </svg>
// //                         Requirement Fulfilled
// //                       </div>
// //                     ) : (
// //                       <button
// //                         className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 flex items-center justify-center text-sm"
// //                         onClick={() => handleInterestedClick(project)}
// //                       >
// //                         <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// //                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"></path>
// //                         </svg>
// //                         I am Interested
// //                       </button>
// //                     )
// //                   )}
// //                 </div>
// //               </div>
// //             ))
// //           ) : (
// //             <div className="col-span-full text-center py-12">
// //               <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
// //               </svg>
// //               <p className="mt-4 text-lg text-gray-500">No projects available at the moment.</p>
// //             </div>
// //           )}
// //         </div>
// //       )}

// //       {/* Congratulations Overlay */}
// //       {showCongrats && (
// //         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">
// //           <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md mx-4 relative overflow-hidden">
// //             <div className="text-center">
// //               <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
// //                 <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
// //                 </svg>
// //               </div>
// //               <h2 className="text-2xl font-bold text-gray-800 mb-2">Congratulations!</h2>
// //               <p className="text-gray-600">You have successfully joined the project!</p>
// //             </div>
            
// //             {/* Confetti animation */}
// //             <div className="absolute inset-0 pointer-events-none">
// //               {Array.from({ length: 50 }).map((_, index) => (
// //                 <div
// //                   key={index}
// //                   className="absolute rounded-full"
// //                   style={{
// //                     left: `${Math.random() * 100}%`,
// //                     top: `${Math.random() * 100}%`,
// //                     width: `${Math.random() * 10 + 5}px`,
// //                     height: `${Math.random() * 10 + 5}px`,
// //                     background: ['#ff6b6b', '#5f27cd', '#48dbfb', '#1dd1a1', '#feca57'][Math.floor(Math.random() * 5)],
// //                     animation: `fall ${Math.random() * 3 + 2}s linear infinite`,
// //                     animationDelay: `${Math.random() * 2}s`,
// //                     opacity: Math.random() * 0.7 + 0.3,
// //                   }}
// //                 />
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* CSS for animations and grid fixes */}
// //       <style jsx>{`
// //         @keyframes fall {
// //           0% { transform: translateY(-10px) rotate(0deg); opacity: 1; }
// //           100% { transform: translateY(100vh) rotate(360deg); opacity: 0; }
// //         }
// //         /* Prevent grid item overflow */
// //         .grid > * {
// //           min-width: 0;
// //         }
// //         /* Ensure consistent card layout */
// //         .grid > div {
// //           display: flex;
// //           flex-direction: column;
// //           overflow: hidden;
// //         }
// //       `}</style>
// //     </div>
// //   );
// // }          Requirement Fulfilled
// // //                       </div>
// // //                     ) : (
// // //                       <button
// // //                         className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 flex items-center justify-center"
// // //                         onClick={() => handleInterestedClick(project)}
// // //                       >
// // //                         <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// // //                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"></path>
// // //                         </svg>
// // //                         I am Interested
// // //                       </button>
// // //                     )
// // //                   )}
// // //                 </div>
// // //               </div>
// // //             ))
// // //           ) : (
// // //             <div className="col-span-full text-center py-12">
// // //               <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// // //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
// // //               </svg>
// // //               <p className="mt-4 text-lg text-gray-500">No projects available at the moment.</p>
// // //             </div>
// // //           )}
// // //         </div>
// // //       )}

// // //       {/* Congratulations Overlay */}
// // //       {showCongrats && (
// // //         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">
// // //           <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md mx-4 relative overflow-hidden">
// // //             <div className="text-center">
// // //               <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
// // //                 <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// // //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
// // //                 </svg>
// // //               </div>
// // //               <h2 className="text-2xl font-bold text-gray-800 mb-2">Congratulations!</h2>
// // //               <p className="text-gray-600">You have successfully joined the project!</p>
// // //             </div>
            
// // //             {/* Confetti animation */}
// // //             <div className="absolute inset-0 pointer-events-none">
// // //               {Array.from({ length: 50 }).map((_, index) => (
// // //                 <div
// // //                   key={index}
// // //                   className="absolute rounded-full"
// // //                   style={{
// // //                     left: `${Math.random() * 100}%`,
// // //                     top: `${Math.random() * 100}%`,
// // //                     width: `${Math.random() * 10 + 5}px`,
// // //                     height: `${Math.random() * 10 + 5}px`,
// // //                     background: ['#ff6b6b', '#5f27cd', '#48dbfb', '#1dd1a1', '#feca57'][Math.floor(Math.random() * 5)],
// // //                     animation: `fall ${Math.random() * 3 + 2}s linear infinite`,
// // //                     animationDelay: `${Math.random() * 2}s`,
// // //                     opacity: Math.random() * 0.7 + 0.3,
// // //                   }}
// // //                 />
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* CSS for animations */}
// // //       <style jsx>{`
// // //         @keyframes fall {
// // //           0% { transform: translateY(-10px) rotate(0deg); opacity: 1; }
// // //           100% { transform: translateY(100vh) rotate(360deg); opacity: 0; }
// // //         }
// // //       `}</style>
// // //     </div>
// // //   );
// // // }

// import { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// export default function StudentView() {
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showCongrats, setShowCongrats] = useState(false);
//   const [selectedProject, setSelectedProject] = useState(null);

//   // Get data from Redux store
//   const studentId = useSelector((state) => state.User.currentUser.rollId);
//   const department = useSelector((state) => state.User.currentUser.department);
//   const navigate = useNavigate();
  
//   // Get backend URL from environment variables
//   const backendURL = process.env.REACT_APP_backend_url;

//   // Fetch all published projects and selected project if any
//   useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         const token = sessionStorage.getItem('Token');
//         setLoading(true);
//         setError(null);

//         // Fetch all published projects for the department
//         const response = await axios.get(
//           `${backendURL}/published_projects/${department}`,
//           {
//             headers: {
//               'Content-Type': 'application/json',
//               Authorization: `Bearer ${token}`,
//             },
//             withCredentials: true,
//           }
//         );

//         setProjects(response.data || []);

//         // Fetch already assigned project for this student
//         const assignedResponse = await axios.post(
//           `${backendURL}/projects_published`,
//           [department, studentId],
//           {
//             headers: {
//               'Content-Type': 'application/json',
//               Authorization: `Bearer ${token}`,
//             },
//             withCredentials: true,
//           }
//         );

//         if (assignedResponse.data.student_project) {
//           setSelectedProject(assignedResponse.data.student_project);
//         }

//         setLoading(false);
//       } catch (err) {
//         console.error('Error fetching projects:', err);
//         setError('Failed to load projects. Please try again later.');
//         setLoading(false);
//       }
//     };

//     fetchProjects();
//   }, [department, studentId, backendURL]);

//   // Handle "I am Interested" button click
//   const handleInterestedClick = async (project) => {
//     const data = {
//       facultyId: project.faculty_id,
//       studentId: studentId,
//       projectId: project.project_id,
//     };

//     try {
//       const token = sessionStorage.getItem('Token');
//       const res = await axios.post(
//         `${backendURL}/add_student_to_project`,
//         data,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           withCredentials: true,
//         }
//       );

//       if (res.data.error) {
//         alert(res.data.error);
//         return;
//       }

//       if (res.data.already_assigned) {
//         alert('You have already selected a project!');
//       } else {
//         setShowCongrats(true);
//         setSelectedProject(res.data.selected_project);
//         setTimeout(() => setShowCongrats(false), 5000);
//       }
//     } catch (error) {
//       console.error('Error adding student to project:', error);
//       alert('Something went wrong. Please try again.');
//     }
//   };

//   // Filter out the selected project from the list
//   const filteredProjects = selectedProject
//     ? projects.filter((p) => p.project_id !== selectedProject.project_id)
//     : projects;

//   return (
//     <div className="max-w-7xl mx-auto px-4 py-8 bg-gray-50 min-h-screen">
//       {/* Page Header */}
//       <h1 className="text-center py-4 mb-6 text-3xl font-bold text-indigo-800 relative">
//         <span className="relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600">
//           Available Projects
//         </span>
//         <div className="absolute inset-0 bg-indigo-100 rounded-lg shadow-md"></div>
//       </h1>

//       {/* Selected Project */}
//       {selectedProject && (
//         <div className="mb-8 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border-l-4 border-emerald-500 p-6 shadow-md">
//           <div className="flex items-center mb-3">
//             <div className="bg-emerald-500 text-white p-2 rounded-full mr-3">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//             <h2 className="text-xl font-bold text-emerald-800">You have joined this project</h2>
//           </div>
          
//           <div className="pl-11">
//             <h3 className="text-lg font-semibold text-emerald-700 mb-2 truncate">{selectedProject.title}</h3>
//             <p className="mb-2"><span className="font-medium">Faculty:</span> {selectedProject.staff_name}</p>
//             <p className="mb-2"><span className="font-medium">Abstract:</span> <span className="line-clamp-3">{selectedProject.abstract}</span></p>
//             <p className="mb-2"><span className="font-medium">Requirements:</span> <span className="line-clamp-2">{selectedProject.requirements}</span></p>
//             <p className="mb-2"><span className="font-medium">Domain:</span> {selectedProject.domain}</p>
//           </div>
//         </div>
//       )}

//       {/* Loading State */}
//       {loading && (
//         <div className="flex flex-col items-center justify-center py-12">
//           <div className="w-16 h-16 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin"></div>
//           <p className="mt-4 text-indigo-600 font-medium">Loading projects...</p>
//         </div>
//       )}

//       {/* Error State */}
//       {error && (
//         <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded shadow-md">
//           <div className="flex">
//             <div className="flex-shrink-0">
//               <svg className="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//               </svg>
//             </div>
//             <div className="ml-3">
//               <p className="text-sm text-red-700">{error}</p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Project Grid */}
//       {!loading && !error && (
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//           {filteredProjects.length > 0 ? (
//             filteredProjects.map((project) => (
//               <div 
//                 key={project.project_id} 
//                 className="bg-white rounded-lg overflow-hidden shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300 flex flex-col min-h-[450px]"
//               >
//                 <div className="p-6 flex-1">
//                   <div className="flex justify-between items-start mb-4">
//                     <h2 className="text-xl font-bold text-gray-800 leading-tight truncate">{project.title}</h2>
//                     <span className="bg-indigo-100 text-indigo-800 text-xs font-semibold px-2.5 py-1 rounded">PUBLISHED</span>
//                   </div>
                  
//                   <div className="space-y-2 mb-4">
//                     <p className="text-gray-700">
//                       <span className="font-medium">Faculty:</span> 
//                       <span>{project.staff_name}</span>
//                     </p>
//                     <p className="text-gray-700">
//                       <span className="font-medium">Abstract:</span> 
//                       <span className="block mt-1 text-sm line-clamp-3">{project.abstract}</span>
//                     </p>
//                     <p className="text-gray-700">
//                       <span className="font-medium">Requirements:</span> 
//                       <span className="block mt-1 text-sm line-clamp-2">{project.requirements}</span>
//                     </p>
//                     <p className="text-gray-700">
//                       <span className="font-medium">Domain:</span> 
//                       <span className="text-sm ml-1">{project.domain}</span>
//                     </p>
//                     <div className="flex items-center">
//                       <span className="font-medium text-gray-700">Students:</span>
//                       <div className="ml-2 flex items-center">
//                         <div className="flex -space-x-2">
//                           {Array.from({ length: Math.min(project.student_count, 3) }).map((_, idx) => (
//                             <div key={idx} className="w-6 h-6 rounded-full bg-indigo-500 text-white flex items-center justify-center text-xs border-2 border-white">
//                               {(project.student_names?.split(',')[idx] || '?').charAt(0)}
//                             </div>
//                           ))}
//                         </div>
//                         <span className="ml-2 text-sm text-gray-600">{project.student_count || 0} / 5</span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Students who joined */}
//                   {project.student_names && project.student_roll_ids && project.student_count > 0 && (
//                     <div className="mt-4 bg-gray-50 p-3 rounded-md">
//                       <p className="font-medium text-sm text-gray-700 mb-1">Students Joined:</p>
//                       <ul className="space-y-1">
//                         {project.student_names.split(',').map((name, idx) => {
//                           const rollIds = project.student_roll_ids.split(',');
//                           return (
//                             <li key={idx} className="text-sm text-gray-600 flex items-center">
//                               <svg className="h-3 w-3 text-indigo-500 mr-1" fill="currentColor" viewBox="0 0 20 20">
//                                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
//                               </svg>
//                               {name.trim()} ({rollIds[idx]?.trim()})
//                             </li>
//                           );
//                         })}
//                       </ul>
//                     </div>
//                   )}
//                 </div>

//                 {!selectedProject && project.student_count < 5 && (
//   <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
//     <button
//       className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 flex items-center justify-center"
//       onClick={() => handleInterestedClick(project)}
//     >
//       <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"></path>
//       </svg>
//       I am Interested
//     </button>
//   </div>
// )}

// {!selectedProject && project.student_count >= 5 && (
//   <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
//     <div className="bg-green-100 text-green-800 text-sm font-medium py-2 px-3 rounded-md flex items-center justify-center">
//       <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
//       </svg>
//       Requirement Fulfilled
//     </div>
//   </div>
// )}

// {/* 
//                 <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
//                   {!selectedProject && (
//                     project.student_count >= 5 ? (
//                       <div className="bg-green-100 text-green-800 text-sm font-medium py-2 px-3 rounded-md flex items-center justify-center">
//                         <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
//                         </svg>
//                         Requirement Fulfilled
//                       </div>
//                     ) : (
//                       <button
//                         className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 flex items-center justify-center"
//                         onClick={() => handleInterestedClick(project)}
//                       >
//                         <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"></path>
//                         </svg>
//                         I am Interested
//                       </button>
//                     )
//                   )}
//                 </div> */}
//               </div>
//             ))
//           ) : (
//             <div className="col-span-full text-center py-12">
//               <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
//               </svg>
//               <p className="mt-4 text-lg text-gray-500">No projects available at the moment.</p>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Congratulations Overlay */}
//       {showCongrats && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">
//           <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md mx-4 relative overflow-hidden">
//             <div className="text-center">
//               <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
//                 <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
//                 </svg>
//               </div>
//               <h2 className="text-2xl font-bold text-gray-800 mb-2">Congratulations!</h2>
//               <p className="text-gray-600">You have successfully joined the project!</p>
//             </div>
            
//             {/* Confetti animation */}
//             <div className="absolute inset-0 pointer-events-none">
//               {Array.from({ length: 50 }).map((_, index) => (
//                 <div
//                   key={index}
//                   className="absolute rounded-full"
//                   style={{
//                     left: `${Math.random() * 100}%`,
//                     top: `${Math.random() * 100}%`,
//                     width: `${Math.random() * 10 + 5}px`,
//                     height: `${Math.random() * 10 + 5}px`,
//                     background: ['#ff6b6b', '#5f27cd', '#48dbfb', '#1dd1a1', '#feca57'][Math.floor(Math.random() * 5)],
//                     animation: `fall ${Math.random() * 3 + 2}s linear infinite`,
//                     animationDelay: `${Math.random() * 2}s`,
//                     opacity: Math.random() * 0.7 + 0.3,
//                   }}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* CSS for animations and grid fixes */}
//       <style jsx>{`
//         @keyframes fall {
//           0% { transform: translateY(-10px) rotate(0deg); opacity: 1; }
//           100% { transform: translateY(100vh) rotate(360deg); opacity: 0; }
//         }
//         /* Prevent grid item overflow */
//         .grid > * {
//           min-width: 0;
//         }
//       `}</style>
//     </div>
//   );
// }


import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

export default function StudentView() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showCongrats, setShowCongrats] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [countdown, setCountdown] = useState(3);

  const studentId = useSelector((state) => state.User.currentUser.rollId);
  const department = useSelector((state) => state.User.currentUser.department);
  const backendURL = process.env.REACT_APP_backend_url;

  const fetchProjects = async () => {
    try {
      const token = sessionStorage.getItem('Token');
      setLoading(true);
      setError(null);

      const response = await axios.get(`${backendURL}/published_projects/${department}`, {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setProjects(response.data || []);

      const assignedResponse = await axios.post(`${backendURL}/projects_published`, [department, studentId], {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      if (assignedResponse.data.student_project) {
        setSelectedProject(assignedResponse.data.student_project);
      }

      setLoading(false);
    } catch (err) {
      console.error('Error fetching projects:', err);
      setError('Failed to load projects. Please try again later.');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, [department, studentId, backendURL]);

  const handleInterestedClick = async (project) => {
    setButtonDisabled(true);
    const data = { facultyId: project.faculty_id, studentId: studentId, projectId: project.project_id };

    try {
      const token = sessionStorage.getItem('Token');
      const res = await axios.post(`${backendURL}/add_student_to_project`, data, {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      if (res.data.error) {
        alert(res.data.error);
        setButtonDisabled(false);
        return;
      }

      if (res.data.already_assigned) {
        alert('You have already selected a project!');
        setButtonDisabled(false);
      } else {
        setSelectedProject(res.data.selected_project);
        setShowCongrats(true);
        setCountdown(3);

        // Countdown and auto-refresh
        const countdownInterval = setInterval(() => {
          setCountdown((prev) => {
            if (prev === 1) {
              clearInterval(countdownInterval);
              setShowCongrats(false);
              setButtonDisabled(false);
              fetchProjects(); // Refresh project list
            }
            return prev - 1;
          });
        }, 1000);
      }
    } catch (error) {
      console.error('Error adding student to project:', error);
      alert('Something went wrong. Please try again.');
      setButtonDisabled(false);
    }
  };

  const filteredProjects = selectedProject
    ? projects.filter((p) => p.project_id !== selectedProject.project_id)
    : projects;

  return (
    <div className="max-w-7xl mx-auto px-4 py-8 bg-gray-50 min-h-screen">
      {/* Header */}
      <h1 className="text-center py-4 mb-6 text-3xl font-bold text-indigo-800 relative">
        <span className="relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600">
          Available Projects
        </span>
        <div className="absolute inset-0 bg-indigo-100 rounded-lg shadow-md"></div>
      </h1>

      {/* Selected Project */}
      {selectedProject && (
        <div className="mb-8 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border-l-4 border-emerald-500 p-6 shadow-md">
          <div className="flex items-center mb-3">
            <div className="bg-emerald-500 text-white p-2 rounded-full mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-emerald-800">You have joined this project</h2>
          </div>
          <div className="pl-11">
            <h3 className="text-lg font-semibold text-emerald-700 mb-2 truncate">{selectedProject.title}</h3>
            <p className="mb-2"><span className="font-medium">Faculty:</span> {selectedProject.staff_name}</p>
            <p className="mb-2"><span className="font-medium">Abstract:</span> {selectedProject.abstract}</p>
            <p className="mb-2"><span className="font-medium">Requirements:</span> {selectedProject.requirements}</p>
            <p className="mb-2"><span className="font-medium">Domain:</span> {selectedProject.domain}</p>
          </div>
        </div>
      )}

      {/* Loading */}
      {loading && (
        <div className="flex flex-col items-center justify-center py-12">
          <div className="w-16 h-16 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin"></div>
          <p className="mt-4 text-indigo-600 font-medium">Loading projects...</p>
        </div>
      )}

      {/* Error */}
      {error && <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded shadow-md">{error}</div>}

      {/* Projects */}
      {!loading && !error && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProjects.length > 0 ? (
            filteredProjects.map((project) => (
              <div key={project.project_id} className="bg-white rounded-lg overflow-hidden shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300 flex flex-col min-h-[450px]">
                <div className="p-6 flex-1">
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-xl font-bold text-gray-800 leading-tight truncate">{project.title}</h2>
                    <span className="bg-indigo-100 text-indigo-800 text-xs font-semibold px-2.5 py-1 rounded">PUBLISHED</span>
                  </div>
                  <p className="text-gray-700"><span className="font-medium">Faculty:</span> {project.staff_name}</p>
                  <p className="text-gray-700"><span className="font-medium">Abstract:</span> {project.abstract}</p>
                  <p className="text-gray-700"><span className="font-medium">Requirements:</span> {project.requirements}</p>
                  <p className="text-gray-700"><span className="font-medium">Domain:</span> {project.domain}</p>
                </div>

                {!selectedProject && (
                  <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
                    {project.student_count < 5 ? (
                      <button
                        disabled={buttonDisabled}
                        className={`w-full ${buttonDisabled ? 'bg-indigo-400' : 'bg-indigo-600 hover:bg-indigo-700'} text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 flex items-center justify-center`}
                        onClick={() => handleInterestedClick(project)}
                      >
                        I am Interested
                      </button>
                    ) : (
                      <div className="bg-green-100 text-green-800 text-sm font-medium py-2 px-3 rounded-md flex items-center justify-center">
                        Requirement Fulfilled
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="col-span-full text-center py-12">
              <p className="mt-4 text-lg text-gray-500">No projects available at the moment.</p>
            </div>
          )}
        </div>
      )}

      {/* Congratulations Overlay */}
      {showCongrats && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">
          <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md mx-4 relative overflow-hidden text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Congratulations!</h2>
            <p className="text-gray-600 mb-2">You have successfully joined the project!</p>
            <p className="text-3xl font-bold text-indigo-600">{countdown}</p>

            {/* Confetti */}
            <div className="absolute inset-0 pointer-events-none">
              {Array.from({ length: 50 }).map((_, index) => (
                <div
                  key={index}
                  className="absolute rounded-full"
                  style={{
                    left: `${Math.random() * 100}%`,
                    top: `${Math.random() * 100}%`,
                    width: `${Math.random() * 10 + 5}px`,
                    height: `${Math.random() * 10 + 5}px`,
                    background: ['#ff6b6b', '#5f27cd', '#48dbfb', '#1dd1a1', '#feca57'][Math.floor(Math.random() * 5)],
                    animation: `fall ${Math.random() * 3 + 2}s linear infinite`,
                    opacity: Math.random() * 0.7 + 0.3,
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fall {
          0% { transform: translateY(-10px) rotate(0deg); opacity: 1; }
          100% { transform: translateY(100vh) rotate(360deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
